var DESCRIPTORS = require('../internals/descriptors');
var fails = require('../internals/fails');
var createElement = require('../internals/document-create-element');

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/ie8-dom-define.js
// module id = 749
// module chunks = 1